import { Point2D } from '@paragon/contract-library';
import { distance2D } from '@paragon/utilities';

import { ReferenceLineIntersection } from '../../store/slices/applicationSlice';

const MAXIMUM_DISTANCE_FROM_MOUSE_TO_SNAP = 1.5;

export function getClosestIntersection(location: Point2D, intersections: readonly ReferenceLineIntersection[]) {
  const testPoint = location;
  let closestDistance = Infinity;
  let closestPoint: ReferenceLineIntersection | null = null;
  for (const intersection of intersections) {
    const distance = distance2D(testPoint.x, testPoint.y, intersection.point.x, intersection.point.y);
    if (distance < closestDistance && distance <= MAXIMUM_DISTANCE_FROM_MOUSE_TO_SNAP) {
      closestDistance = distance;
      closestPoint = intersection;
    }
  }
  return closestPoint;
}
